import { lazy, type FC, Suspense } from 'react';
import { useClientState } from 'dibs-react-hooks/exports/useClientState.ts';
import { type EndAuctionProps } from './EndAuctionModal.tsx';

const EndAuctionModal = lazy(
    () => import(/* webpackChunkName: "EndAuctionModal" */ './EndAuctionModal.tsx')
);

export const EndAuctionModalLazy: FC<EndAuctionProps> = props => {
    const isClient = useClientState();
    return isClient ? (
        <Suspense fallback="">
            <EndAuctionModal {...props} />
        </Suspense>
    ) : null;
};
